import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import ContentRelatorio from "./ErrosPorQuestao/ContentRelatorio";

import "./styles.scss";
import ContentRelatorioUsuario from "./QuestoesUsuario/ContentUsuarioQuestao";

const Relatorio = () => {
  const [key, setKey] = useState('relatorio'); // Default active tab

  return (
    <div className="relatorio-container">
      <div className="admin-header">
        <h1>Relatórios</h1>
      </div>
      <hr />
      <Tabs
        defaultActiveKey="questoes"
        id="relatorio-tabs"
        // activeKey={key}
        onSelect={(k) => setKey(k)}
        className="ms-2 p-2 text-primary "
      >
        <Tab eventKey="questoes" title="Questões" >
          <ContentRelatorio />
        </Tab>
        <Tab eventKey="usuario" title="Usuários">
          <ContentRelatorioUsuario />
        </Tab>
      </Tabs>
    </div>

  );
};

export default Relatorio;
